import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { takeWhile } from 'rxjs';

export class PrComparaisonCell {
  label: string;
  type: any;
  value: any;
  prefix: any;
  suffix: any;
  checked: boolean;
  labelTooltip?: string;
  cross?: boolean;
}

export class PrComparaisonItem {
  label?: string;
  color?: string;
  cells?: PrComparaisonCell[];
  optimized?: boolean = false;
  overhead?: string;
  overheadColor?: string;
}

@Component({
    selector: 'pr-comparaison',
    templateUrl: './pr-comparaison.component.html',
    styleUrls: ['./pr-comparaison.component.scss'],
    standalone: false
})
export class PrComparaisonComponent implements OnInit, OnDestroy {
  @Input() subjects: PrComparaisonItem[];
  public _ = _;
  mdq;
  alive = true;

  constructor(private breakpoint: BreakpointObserver) {}

  ngOnInit() {
    this.breakpoint
      .observe(['(max-width: 992px)'])
      .pipe(takeWhile(() => this.alive))
      .subscribe(obs => (this.mdq = obs.matches));
  }

  get rows() {
    let rows = [];
    for (let cell of this.subjects[0].cells) rows.push(cell);
    return rows;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
